export const saveToLocalStorage = (key, value) => {
  if (typeof window !== "undefined") {
    localStorage.setItem(key, JSON.stringify(value));
  }
};

export const fetchFromLocalStorage = (key) => {
  if (typeof window !== "undefined") {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch (e) {
      return;
    }
  }
};

export const removeFromLocalStorage = (key) => {
  if (typeof window !== "undefined") {
    localStorage.removeItem(key);
  }
};

export const clearLocalStorage = () => {
  if (typeof window !== "undefined") {
    localStorage.clear();
  }
};
